import { api } from "./api";

export interface TaxRate {
  id: string;
  code: string;
  name: string;
  rate_pct: string;
  is_input_claimable: boolean;
  is_system: boolean;
  is_active: boolean;
}

export interface WhtRule {
  id: string;
  code: string;
  name: string;
  rate_pct: string;
  ird_reference: string | null;
  trigger_type: string;
  applies_to: string[];
  suggest_default: boolean;
  is_system: boolean;
  is_active: boolean;
}

export interface ApitBracket {
  id: string;
  table: string;
  position: number;
  from_cents: string;
  to_cents: string | null;
  rate_pct: string;
  fixed_deduction_cents: string;
  notes: string | null;
}

export const taxSettingsApi = {
  // rates
  listRates: () => api.get<{ rates: TaxRate[] }>("/tax-settings/rates"),
  createRate: (body: {
    code: string;
    name: string;
    ratePct: number;
    isInputClaimable?: boolean;
  }) => api.post<TaxRate>("/tax-settings/rates", body),
  updateRate: (id: string, body: Partial<{ code: string; name: string; ratePct: number; isInputClaimable: boolean; isActive: boolean }>) =>
    api.patch<TaxRate>(`/tax-settings/rates/${id}`, body),
  deleteRate: (id: string) => api.delete<void>(`/tax-settings/rates/${id}`),

  // WHT
  listWht: () => api.get<{ rules: WhtRule[] }>("/tax-settings/wht"),
  createWht: (body: {
    code: string;
    name: string;
    ratePct: number;
    irdReference?: string | null;
    triggerType: string;
    appliesTo?: string[];
    suggestDefault?: boolean;
  }) => api.post<WhtRule>("/tax-settings/wht", body),
  updateWht: (id: string, body: Partial<{ code: string; name: string; ratePct: number; irdReference: string | null; triggerType: string; appliesTo: string[]; suggestDefault: boolean; isActive: boolean }>) =>
    api.patch<WhtRule>(`/tax-settings/wht/${id}`, body),
  deleteWht: (id: string) => api.delete<void>(`/tax-settings/wht/${id}`),

  // APIT
  listApit: () => api.get<{ brackets: ApitBracket[] }>("/tax-settings/apit"),
  createApit: (body: {
    table: "01" | "02" | "07";
    position: number;
    fromCents: string;
    toCents: string | null;
    ratePct: number;
    fixedDeductionCents?: string;
    notes?: string | null;
  }) => api.post<{ id: string }>("/tax-settings/apit", body),
  updateApit: (id: string, body: Partial<{ table: "01"|"02"|"07"; position: number; fromCents: string; toCents: string | null; ratePct: number; fixedDeductionCents: string; notes: string | null }>) =>
    api.patch<{ id: string }>(`/tax-settings/apit/${id}`, body),
  deleteApit: (id: string) => api.delete<void>(`/tax-settings/apit/${id}`),
};
